var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ctk-list-header',{staticClass:"missions-list-header tw-px-4 flex-fixed",attrs:{"title":_vm._f("capitalize")(_vm.title),"subtitle":_vm.$tc(_vm.subtitlePath, _vm.getMissionsMeta.item_count, {
    count: _vm.$n(_vm.getMissionsMeta.item_count)
  })}},[_c('mission-list-header-filters')],1)}
var staticRenderFns = []

export { render, staticRenderFns }